export default __webpack_public_path__ + "static/media/Wordmark_Dark.b599f14b.svg";